import React, {useState} from 'react';
import classNames from 'classnames'

function DropdownOption({setter, code, label}) {

  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);
  const className = classNames("active-result", {"highlighted": hovered});

  return (<li className={className} onClick={() => setter(code)} onMouseEnter={toggleHover} onMouseLeave={toggleHover}>{label}</li>)
}

export default DropdownOption;
